export default {
  //バリデーション
  SUBMIT_ERROR_TITLE: "Error / 錯誤",
  VALIDATION_EMPTY_MAIL_ADDRESS: "請輸入電子郵件地址。",
  VALIDATION_INVALID_ADDRESS: "電子郵件地址格式不正確。",
  VALIDATION_EMPTY_PASSWORD: "請輸入密碼。",
  VALIDATION_INVALID_PASSWORD: "請輸入包含半形英數字符的8位以上密碼。",
  VALIDATION_UNMATCH_PASSWORD: "密碼不一致，請重新輸入。",
};
